export default "__VITE_ASSET__d2a7c9bf__"